import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as Constants from './constants'

export const FormActions = Form.createActionsMap(Constants.CHART_FILTER)

export const esSearch = Elasticsearch.createEsSearch(Constants.CHART)



// WEBPACK FOOTER //
// ./src/pages/reports/analytics/actions.ts